import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CSpinner } from "@coreui/react";
import mediaServiceClient from "../services/Application/mediaServiceClient";

const FileViewerPage = () => {
  const { type, fileName } = useParams();
  const containerRef = useRef(null);

  // Guard to ensure fetchFile runs only once
  const hasFetched = useRef(false);

  useEffect(() => {
    const fetchFile = async () => {
      if (hasFetched.current) return; // Prevent multiple executions
      hasFetched.current = true; // Mark as executed

      await downloadFile(fileName);
    };

    fetchFile();
  }, [type, fileName]);

  const downloadFile = async (mediaId) => {
    try {
      const result = await mediaServiceClient.download(mediaId);

      if (result.succeeded) {
        const downloadUrl = result.object.downloadUrl;

        if (downloadUrl) {
          window.open(downloadUrl, "_blank");
        } else {
          toast.error("No download URL available");
        }
      } else {
        toast.error(result.errorMessage || "Failed to download document");
      }
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Error downloading the document");
    }
  };

  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CSpinner color="info" className="card-spinner" />
    </div>
  );
};

export default FileViewerPage;
